// Version : 1.0.0
// Author : AGALYA

const HousePhotosActionType = {
	/** ***************** update House Photos Start ************************/
	UPDATE_HOUSE_PHOTOS_START: 'update_house_photos_start',
	UPDATE_HOUSE_PHOTOS_SUCCESS: 'update_house_photos_success',
	UPDATE_HOUSE_PHOTOS_FAILURE: 'update_house_photos_failure',
	UPDATE_HOUSE_PHOTOS_RESPONSE_REST_START: 'update_house_photos_response_reset_start',
	UPDATE_HOUSE_PHOTOS_RESPONSE_CHANGED: 'update_house_photos_response_changed',
	/** ***************** update House Photos End ************************/
};

export default HousePhotosActionType;
